import { CallApi, handleJSONResponse } from './common';
import { Subscription } from '@services/subscription/types/subscription';
import { NewSubscription } from '@services/subscription/types/new-subscription';
import { SubscriptionType } from '@services/subscription/types/subscription-type';

const callAPI = CallApi('subscriptions');

export const get = async (clientId: string): Promise<Subscription> => {
  const response = await callAPI(`/${clientId}`, 'GET');

  return handleJSONResponse(response);
};

export const create = async (
  clientId: string,
  subscription: NewSubscription | Subscription
): Promise<Subscription> => {
  const response = await callAPI(`/${clientId}`, 'POST', subscription);

  return handleJSONResponse(response);
};

export const cancel = async (
  clientId: string,
  type?: SubscriptionType
): Promise<Subscription> => {
  const response = await callAPI(`/${clientId}/${type || 'artist'}`, 'DELETE');

  return handleJSONResponse(response);
};
